import { z } from 'zod'
import { countryCodes, identifierTypes } from '@/shared/models/debtorModels'

export const BulkDebtorRowSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    identifierType: z.enum(identifierTypes, {
        errorMap: () => ({ message: 'Invalid identifierType' })
    }),
    identifierValue: z.string().min(1, 'identifierValue is required'),
    identifierCountry: z.enum(countryCodes, {
        errorMap: () => ({ message: 'Invalid identifierCountry' })
    }),
    addressFirst: z.string().min(1, 'Address line is required'),
    addressCity: z.string().min(1, 'City is required'),
    addressPostal: z.string().min(1, 'Postal code is required'),
    addressCountry: z.enum(countryCodes, {
        errorMap: () => ({ message: 'Invalid addressCountry' })
    }),
    contactEmail: z.string().email('Invalid contact email'),
    contactPhoneNumber: z.string().default(''),
    contactFirstName: z.string().optional().default(''),
    contactLastName: z.string().optional().default(''),
    contactPosition: z.string().optional().default('')
})

export type BulkDebtorRow = z.infer<typeof BulkDebtorRowSchema>

const bulkUploadErrorCodes = ['EMPTY_FILE', 'MISSING_HEADERS', 'PARSING_ERROR', 'UNKNOWN_ERROR'] as const

export type BulkUploadError = {
    code: (typeof bulkUploadErrorCodes)[number]
    details?: {
        missingHeaders?: string[]
        expectedHeaders?: string[]
        csvHeaders?: string[]
    }
    originalError?: unknown
}

export const isBulkUploadError = (obj: unknown): obj is BulkUploadError =>
    typeof obj === 'object' && obj !== null && 'code' in obj && bulkUploadErrorCodes.some((code) => code === obj.code)
